import React, { Suspense, lazy, memo } from 'react';
import ScrollToTop from './ScrollToTop';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

import SliderSkeleton from "./SliderSkeleton";
import TabsSkeleton from './TabsSkeleton';
import AllHotNewsSkeleton from './AllHotNewsSkeleton';

import TajaKhabarCard from './TajaKhabarCard';
import KhelHome from './KhelHome';
import WorldscardsHome from './WorldscardsHome';
import BollywoodCardsHome from './BollywoodCardsHome';

// Lazy Components
const AllHotNews = lazy(() => import('./AllHotNews'));
const BigCard = lazy(() => import('./BigCard'));
const SmallAdd = lazy(() => import('./SmallAdd'));
const AroundTheWorld = lazy(() => import('./AroundTheWorld'));
const Tabs = lazy(() => import('./Tabs'));
const Slider = lazy(() => import('./Slider'));
const Blocks = lazy(() => import('./Blocks'));
const Rashifal = lazy(() => import('./Rashifal'));

// Memo Components
const MemoizedSlider = memo(Slider);
const MemoizedTabs = memo(Tabs);
const MemoizedSmallAdd = memo(SmallAdd);
const MemoizedAroundTheWorld = memo(AroundTheWorld);

function Home() {
  return (
    <>
      {/* ----- SEO HEAD TAGS ----- */}
      <Helmet>
        <title>
          हिंदी समाचार आज की ताज़ा अपडेट – देश-दुनिया की बड़ी खबरें सबसे पहले और सटीक!
        </title>

        <meta
          name="description"
          content="देश-दुनिया की बड़ी खबरें अब एक क्लिक में—राजनीति, खेल, मनोरंजन और तकनीकी की ताज़ा अपडेट हिंदी में पढ़ें।"
        />

        <link rel="canonical" href="https://shabdtoday.com/" />
      </Helmet>

      {/* ------- HIDDEN SEO HEADINGS (DO NOT REMOVE) ------- */}
      <h1 className="hidden-start">हिंदी समाचार आज की ताज़ा अपडेट</h1>
      <h2 className="hidden-start">देश और विदेश की बड़ी खबरें</h2>
      <h3 className="hidden-start">राजनीति | खेल | मनोरंजन | तकनीकी खबरें हिंदी में</h3>

      {/* ------- MAIN HOME PAGE LAYOUT START ------- */}
      <div className="ak-main-wrap">
        <div className="ak-header-wrap ak-header-bottom-shadow">
          <div className="ak-container">
            <div className="ak-content-wrap">
              <div className="ak-container">
                <div className="ak-content vc-content">

                  <section className="wpb-content-wrapper">
                    <div className="row vc_row">
                      <div className="ak_vc_container">

                        {/* ---------------- LEFT COLUMN ---------------- */}
                        <div className="wpb_column ak_column_2 vc_column_container vc_col-sm-8">
                          <div className="ak_vc_wrapper wpb_wrapper">

                            {/* TOP SLIDER */}
                            <Suspense fallback={<SliderSkeleton />}>
                              <MemoizedSlider />
                            </Suspense>

                            {/* मध्य प्रदेश Section */}
                            <div
                              className="ak-block ak-block-list-12 ak-block-module-inner-boxed ak-block-width-2 clearfix"
                              id="block_mp"
                            >
                              <div className="ak-block-header ak-block-header-style-5 no-tabs mb-2">
                                <div className="main-wdgt container">
                                  <div className="wdgt-hdng mt-2">
                                    <h1 className="head">
                                      <Link to="/MadhyaPradesh-News" title="मध्य प्रदेश">
                                        मध्य प्रदेश
                                      </Link>
                                    </h1>
                                  </div>
                                </div>
                              </div>

                              <div className="ak-block-inner clearfix">
                                <div className="ak-block-posts clearfix">
                                  {/* Top Hot News */}
                                  <Suspense fallback={<AllHotNewsSkeleton />}>
                                    <AllHotNews />
                                  </Suspense>

                                  <hr />

                                  {/* BigCard */}
                                  <Suspense fallback={<div />}>
                                    <BigCard />
                                  </Suspense>

                                  <hr />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>

                        {/* ---------------- RIGHT COLUMN ---------------- */}
                        <div className="wpb_column ak_column_1 vc_column_container vc_col-sm-4">
                          <div className="ak_vc_wrapper wpb_wrapper container">

                            {/* Tabs */}
                            <Suspense fallback={<TabsSkeleton />}>
                              <MemoizedTabs />
                            </Suspense>

                            {/* Ads */}
                            <Suspense fallback={<div>Loading Ads...</div>}>
                              <MemoizedSmallAdd />
                            </Suspense>

                            {/* Around The World */}
                            <Suspense fallback={<div>Loading Around the World...</div>}>
                              <MemoizedAroundTheWorld />
                            </Suspense>
                          </div>
                        </div>
                      </div>
                    </div>

                    {/* Blocks */}
                    <div className="container mt-2">
                      <Suspense fallback={<div />}>
                        <Blocks />
                      </Suspense>
                    </div>

                    {/* Rashifal */}
                    <div className="container mt-2">
                      <Suspense fallback={<div>Loading...</div>}>
                        <Rashifal disableHelmet={true} />
                      </Suspense>
                    </div>

                    {/* दुनिया */}
                    <div className="container mt-3">
                      <div className="wdgt-hdng">
                        <h1 className="head">
                          <Link to="/World-News" title="दुनिया">
                            <span style={{ color: "black" }}>दुनिया</span>
                          </Link>
                        </h1>
                      </div>
                      <WorldscardsHome />
                    </div>

                    {/* खेल */}
                    <div className="container mt-3">
                      <div className="wdgt-hdng">
                        <h1 className="head">
                          <Link to="/Khel-News" title="खेल">
                            <span style={{ color: "black" }}>खेल</span>
                          </Link>
                        </h1>
                      </div>
                      <KhelHome />
                    </div>

                    {/* बॉलीवुड */}
                    <div className="container mt-3">
                      <div className="wdgt-hdng">
                        <h1 className="head">
                          <Link to="/Bollywood-News" title="बॉलीवुड">
                            <span style={{ color: "black" }}>बॉलीवुड</span>
                          </Link>
                        </h1>
                      </div>
                      <BollywoodCardsHome />
                    </div>

                    {/* ताजा खबरें */}
                    <div className="container mt-3 mb-4">
                      <div className="wdgt-hdng">
                        <h1 className="head">
                          <Link to="/TajaKhabar-News" title="ताजा खबरें">
                            <span style={{ color: "black" }}>ताजा खबरें</span>
                          </Link>
                        </h1>
                      </div>
                      <TajaKhabarCard disableHelmet={true} />
                    </div>

                  </section>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <ScrollToTop />
    </>
  );
}

export default Home;
